import { Alert, Grid, Stack } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { LiveDetailsHeader } from '../components/LiveDetailsHeader';
import { LiveLinesTable } from '../components/LiveLinesTable';
import { LivePackagesTable } from '../components/LivePackagesTable';

export function LiveDetails() {
  const { liveId } = useParams();

  if (!liveId) return <Alert color="red">Chýba parameter liveId</Alert>;

  return (
    <Stack p="md">
      <Grid>
        <Grid.Col span={12}>
          <LiveDetailsHeader liveId={liveId} />
        </Grid.Col>
        <Grid.Col span={8}>
          <LiveLinesTable liveId={liveId} />
        </Grid.Col>
        <Grid.Col span={4}>
          <LivePackagesTable liveId={liveId} />
        </Grid.Col>
      </Grid>
    </Stack>
  );
}
